<script setup>
import { nextTick, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { bus, RUN_GUIDE, GUIDE_REGISTER, GUIDE_UNREGISTER } from "@/bus/bus";
import { getDriver } from "@/tours/driverInstance";
import { bizLocationListSteps, bizLocationCreateSteps } from "@/tours/bizLocationTour";

const route = useRoute();
const drv = getDriver();

function focusIntoView(sel) {
  const el = document.querySelector(sel);
  if (!el) return;
  el.scrollIntoView({ behavior: "instant", block: "center" });
  requestAnimationFrame(() => drv.refresh());
}

function inferGuideTypeFromRoute(r = route) {
  if (r.query?.view) return String(r.query.view);
  if (r.meta?.guideView) return String(r.meta.guideView);

  switch (r.name) {
    case "BizLocations":
      return "list";
    case "BizLocationCreate":
      return "create";
    case "BizLocationEdit":
      return null; // ✅ edit 은 가이드 없음
    default:
      return "list";
  }
}

async function run(type) {
  const guideType = type ?? inferGuideTypeFromRoute();

  if (!guideType) {
    // ✅ 가이드 없음 처리
    return;
  }

  const steps =
    guideType === "list"
      ? bizLocationListSteps(focusIntoView)
      : bizLocationCreateSteps(focusIntoView);

  drv.setSteps(steps);
  await nextTick();
  requestAnimationFrame(() => {
    drv.drive();
    requestAnimationFrame(() => drv.refresh());
  });
}

onMounted(() => {
  const guideType = inferGuideTypeFromRoute();

  if (guideType) {
    bus.emit(GUIDE_REGISTER);
    const handler = (type) => run(type);
    bus.on(RUN_GUIDE, handler);

    onUnmounted(() => {
      bus.off(RUN_GUIDE, handler);
      bus.emit(GUIDE_UNREGISTER);
    });
  } else {
    // edit 등 가이드 없는 경우 → 등록 안 함
  }
});

defineExpose({ run });
</script>

<template></template>
